import React from "react";
import styles from "./ToastContainer.module.css";
import { useToastStore } from "@store";

const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useToastStore();

  return (
    <div
      className={styles.toastContainer}
      aria-live="polite"
      aria-atomic="true"
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`${styles.toast} ${styles[toast.type]}`}
          role="alert"
        >
          <span className={styles.message}>{toast.message}</span>
          {toast.action && (
            <button
              onClick={() => {
                toast.action?.onClick();
                removeToast(toast.id);
              }}
              className={styles.actionButton}
            >
              {toast.action.label}
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
